export default __webpack_public_path__ + "static/media/screen22.2bdde42d.svg";